import React from 'react';
import { motion } from 'framer-motion';
import GrainOverlay from './GrainOverlay';

const CTA: React.FC = () => {
  const handleGetStarted = () => {
    window.location.href = '/contact';
  };

  const handleViewProducts = () => {
    const element = document.querySelector('#products');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="demo" className="py-20 relative overflow-hidden">
      <GrainOverlay />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <motion.div
          className="relative rounded-3xl overflow-hidden"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          {/* Container with warm background */}
          <div className="relative bg-primary-50 dark:bg-dark-800 p-12 md:p-16 text-center">
            {/* Decorative blob behind */}
            <div
              className="absolute -top-20 -right-20 w-60 h-60 animate-blob-morph opacity-[0.12] dark:opacity-[0.06]"
              style={{ backgroundColor: '#6b8f71' }}
            />
            <div
              className="absolute -bottom-16 -left-16 w-48 h-48 animate-blob-morph-2 opacity-[0.10] dark:opacity-[0.05]"
              style={{ backgroundColor: '#c2703e' }}
            />

            {/* Content */}
            <div className="relative z-10">
              <motion.h2
                className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-dark-900 dark:text-dark-100 mb-6"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.1 }}
              >
                Ready to Transform Your Healthcare Workflow?
              </motion.h2>

              <motion.p
                className="text-lg md:text-xl text-dark-500 dark:text-dark-300 mb-10 leading-relaxed max-w-2xl mx-auto"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.2 }}
              >
                Join thousands of healthcare professionals who trust BioAxis for their daily operations
              </motion.p>

              <motion.div
                className="flex flex-col items-center gap-4"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.3 }}
              >
                <motion.button
                  onClick={handleGetStarted}
                  className="btn-primary text-lg px-10 py-4"
                  whileHover={{ scale: 1.08 }}
                  whileTap={{ scale: 0.95 }}
                  transition={{ type: 'spring', stiffness: 400, damping: 15 }}
                >
                  Get Started Today
                </motion.button>

                <motion.button
                  onClick={handleViewProducts}
                  className="text-primary-600 dark:text-primary-400 hover:text-secondary-500 dark:hover:text-secondary-400 font-semibold text-sm transition-colors duration-200"
                  whileHover={{ y: -2 }}
                >
                  View all products
                </motion.button>
              </motion.div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTA;
